import React, {Component} from "react";
import MomentDate from "../../../../components/MomentDate";

class Event extends Component {
	render() {
		const {event} = this.props;
		const {team1, team2} = event;
		const {results} = event;

		return (
			<div className="tbody">
				<div className="tr">
					<div className="td time">
						<MomentDate date={event.time} isLive={true}/>
					</div>
					<div className="td players">{team1} - {team2}</div>
					<div className="td score">{results.general} {results.periods !== '' && `(${results.periods})`}</div>
				</div>
			</div>
		);
	}
}

export default Event;


// WEBPACK FOOTER //
// ./src/app/pages/Result/Live/modules/Event.js